// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import "@hotwired/turbo-rails"
import * as THREE from "three"
import Globe from "globe.gl"

// Esto expone THREE y Globe globalmente
window.THREE = THREE
window.Globe = Globe

import "../controllers"

// Mount Vue public components
import { createApp } from 'vue'
import ConsultaForm from '../components/public/ConsultaForm.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('consulta-form-app')
  if (el) createApp(ConsultaForm).mount(el)
})

